import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule, CommonModule],
  exports: [LandingComponent],
  declarations: [LandingComponent],
})
export class LandingModule {}
